<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <Tab />
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="UID"
                clearable
                v-model="userId"
                class="userUid_ipt"
                size="mini"
              >
                <!-- <img :src="userUid" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>

          <div class="item">
            <!-- <div class="txt">仓位模式</div> -->
            <div class="ipt">
              <el-select
                size="mini"
                @change="changeCoin"
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="positionType"
                placeholder="限制模块"
              >
                <!-- <el-option label="全部仓位模式" value=""> </el-option> -->
                <el-option
                  v-for="item in [
                    { id: 1, value: '全仓' },
                    { id: 2, value: '逐仓' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <!-- <div class="txt">订单平仓日期</div> -->
            <div class="ipt">
              <el-date-picker
                size="mini"
                v-model="value1"
                type="daterange"
                align="right"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                unlink-panels
                clearable
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="item">
            <Add @refresh="refreshList"></Add>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch"
              >重置</el-button
            >
          </div>
          <div class="item">
            <a @click="getExcel" target="_blank">导出Excel</a>
          </div>
        </div>
      </div>

      <user-list @refresh="refreshList"></user-list>
      <Del />
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import './store'
import UserList from './components/list'
import Tab from '../components/Tab'
import Add from './components/add'
import { mapState, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import userUid from '@/assets/input/userUid.png'
import invite from '@/assets/input/invite.png'
import channel from '@/assets/input/channel.png'

import Del from './components/del'
export default {
  name: 'ContactHistory',
  components: {
    UserList,
    Tab,
    Del,
    Add,
  },
  data() {
    return {
      channelUserId: '',
      positionType: '',
      positionSide: '',
      invite,
      channel,
      userUid,
      type: 1,
      value2: '',
      dialogVisible: false,
      userId: '',
      id: '',
      channelUserId: '',
      symbolId: '',
      value1: '',

      // value1: [
      //   moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     "YYYY-MM-DD"
      //   ),
      //   new Date().getFullYear() +
      //     "-" +
      //     (new Date().getMonth() + 1) +
      //     "-" +
      //     new Date().getDate(),
      // ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapState('topPartner', ['topPartner']),
    ...mapState('blocklistManagement', [
      'totalRealizedProfit',
      'totalFee',
      'pagination',
      'symbolList',
      'orderBy',
    ]),
  },
  methods: {
    ...mapActions('blocklistManagement', [
      'getHistory',
      'getHistoryInfo',
      'exportExcel',
      'getSymbolList',
    ]),

    ...mapMutations('blocklistManagement', ['setOrderBy', 'setDelVisible']),
    showDel() {
      this.setDelVisible(true)
    },
    changeCoin(e) {
      this.getHistory({
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        id: this.id,
        type: this.type,
        symbolId: this.symbolId,
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
        positionType: this.positionType,
        positionSide: this.positionSide,
        orderBy: this.orderBy,
        ...this.pagination,
        page: 1,
      })
      this.getHistoryInfo({
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        id: this.id,
        type: this.type,
        symbolId: this.symbolId,
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
        positionType: this.positionType,
        positionSide: this.positionSide,
      })
    },
    refreshList(data = {}) {
      this.getHistory({
        id: this.id,
        symbolId: this.symbolId,
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        type: this.type,
        userId: this.userId,
        positionType: this.positionType,
        positionSide: this.positionSide,
        orderBy: this.orderBy,
        ...this.pagination,
        ...data,
      })
      this.getHistoryInfo({
        id: this.id,
        symbolId: this.symbolId,
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        type: this.type,
        positionType: this.positionType,
        positionSide: this.positionSide,
        ...data,
      })
    },
    getExcel() {
      this.exportExcel({
        id: this.id,
        symbolId: this.symbolId,
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        type: this.type,
        userId: this.userId,
        positionType: this.positionType,
        positionSide: this.positionSide,
        ...this.pagination,
      }).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
        link.style.display = 'none'
        // 设置连接
        link.href = URL.createObjectURL(blob) //将文件流转化为blob地址
        console.log('link-href', link.href)
        link.download = '历史仓位记录'
        document.body.appendChild(link)
        // 模拟点击事件
        link.click() //设置点击事件
      })
    },
    changeTime(e) {
      this.getHistory({
        // channelId: this.userInfo.channelId,
        type: this.type,
        channelUserId: this.channelUserId,
        userId: this.userId,
        id: this.id,
        symbolId: this.symbolId,
        positionType: this.positionType,
        positionSide: this.positionSide,
        orderBy: this.orderBy,
        startTime: e[0],
        endTime: e[1],
        ...this.pagination,
        page: 1,
      })
      this.getHistoryInfo({
        // channelId: this.userInfo.channelId,
        type: this.type,
        channelUserId: this.channelUserId,
        userId: this.userId,
        id: this.id,
        symbolId: this.symbolId,
        positionType: this.positionType,
        positionSide: this.positionSide,
        startTime: e[0],
        endTime: e[1],
      })
    },
    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
      ]
      this.handleSearch()
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
      ]
      this.handleSearch()
    },
    handleSearch() {
      this.getHistory({
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        id: this.id,
        type: this.type,
        symbolId: this.symbolId,
        positionType: this.positionType,
        positionSide: this.positionSide,
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
        orderBy: this.orderBy,
        ...this.pagination,
        page: 1,
      })
      this.getHistoryInfo({
        channelId: this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        id: this.id,
        type: this.type,
        symbolId: this.symbolId,
        positionType: this.positionType,
        positionSide: this.positionSide,
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
      })
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false
    },
    onOpen() {},
    onClose() {
      this.$refs['elForm'].resetFields()
      this.dialogVisible = false
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs['elForm'].resetFields()
      this.dialogVisible = false
    },
    // clearSort() {
    //   this.setOrderBy(null)
    //   this.$refs.table.doSort('', '')
    // },
  },
  created() {
    this.getSymbolList()
    this.getHistory({
      channelId: this.topPartner,
      channelUserId: this.channelUserId,
      userId: this.userId,
      type: this.type,
      positionType: this.positionType,
      positionSide: this.positionSide,
      id: this.id,
      symbol: this.symbolId,
      startTime: this.value1 ? this.value1[0] : '',
      endTime: this.value1 ? this.value1[1] : '',
      orderBy: this.orderBy,
      ...this.pagination,
    })
    this.getHistoryInfo({
      channelId: this.topPartner,
      channelUserId: this.channelUserId,
      userId: this.userId,
      type: this.type,
      positionType: this.positionType,
      positionSide: this.positionSide,
      id: this.id,
      symbol: this.symbolId,
      startTime: this.value1 ? this.value1[0] : '',
      endTime: this.value1 ? this.value1[1] : '',
      ...this.pagination,
    })
  },
  beforeDestroy() {
    this.setOrderBy(null)
  },
}
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
